<div class="notes-form-container">
    <div class="form-container notes-form-fields">
        <div class="row" [formGroup]="form">
            <div class="row">
                <div class="col-lg-4">
                    <h5>
                        {{ 'aumico_notes_notestype_form_name' | i18next }}
                        <span class="mandatory-field-asterisk">*</span>
                    </h5>

                    <aum-input [aumFormControl]="form.controls[fieldsName.NAME]">
                        <aum-form-field-label>
                            {{ 'aumico_notes_notestype_form_name' | i18next }}
                        </aum-form-field-label>
                        <aum-form-error
                            *ngIf="form.controls[fieldsName.NAME].touched && form.controls[fieldsName.NAME].invalid"
                        >
                            <span *ngIf="form.controls[fieldsName.NAME].errors['required']"
                                >{{ mandatoryError | i18next }}</span
                            >
                            <span *ngIf="form.controls[fieldsName.NAME].errors['minlength']"
                                >{{ nameMinLength | i18next }}</span
                            >
                        </aum-form-error>
                    </aum-input>
                </div>

                <div class="col-lg-4">
                    <h5>
                        {{ 'aumico_notes_notestype_form_title' | i18next }}
                        <span class="mandatory-field-asterisk">*</span>
                    </h5>
                    <div>
                        <aum-input [aumFormControl]="form.controls[getPropertyName(fieldsName.TITLE, defaultLanguage)]">
                            <aum-form-field-label>
                                {{ 'aumico_notes_notestype_form_title' | i18next }}
                            </aum-form-field-label>

                            <aum-form-error
                                *ngIf="form.controls[getPropertyName(fieldsName.TITLE, defaultLanguage)].touched
                  && form.controls[getPropertyName(fieldsName.TITLE, defaultLanguage)].invalid"
                            >
                                <span>{{ mandatoryError | i18next }}</span>
                            </aum-form-error>
                        </aum-input>
                    </div>
                </div>

                <div class="col-lg-4">
                    <h5>
                        {{ 'aumico_notes_notestype_form_components' | i18next }}
                        <span class="mandatory-field-asterisk">*</span>
                    </h5>

                    <aum-draggable-multi-select
                        #componentsSelection
                        [options]="components"
                        (selectionChange)="getCurrentSelectionAndDifferenceOfPreviousSelection($event)"
                        [aumFormControl]="form.controls[fieldsName.NOTES_COMPONENTS]"
                    >
                    </aum-draggable-multi-select>
                    <mat-error
                        *ngIf="form.controls[fieldsName.NOTES_COMPONENTS].touched && form.controls[fieldsName.NOTES_COMPONENTS].invalid"
                    >
                        <span *ngIf="form.controls[fieldsName.NOTES_COMPONENTS].errors['required']"
                            >{{ mandatoryError | i18next }}</span
                        >
                    </mat-error>
                </div>
            </div>

            <div class="row">
                <h5>
                    {{ 'aumico_notes_notestype_form_information' | i18next }}
                    <span class="mandatory-field-asterisk">*</span>
                </h5>
                <div>
                    <quill-editor
                        [preserveWhitespace]="true"
                        formControlName="{{fieldsName.INFORMATION}}-{{defaultLanguage}}"
                        id="{{fieldsName.INFORMATION}}-{{defaultLanguage}}"
                        [modules]="toolbarOptions"
                        [sanitize]="true"
                        [styles]="{ height: '200px' }"
                        [ngModel]="data?.information[defaultLanguage]"
                    >
                    </quill-editor>
                    <mat-error
                        *ngIf="form.controls[getPropertyName(fieldsName.INFORMATION, defaultLanguage)].touched &&
              form.controls[getPropertyName(fieldsName.INFORMATION, defaultLanguage)].invalid"
                    >
                        <span>{{ mandatoryError | i18next }}</span>
                    </mat-error>
                </div>
            </div>
        </div>

        <mat-error *ngIf="isNameExist">{{nameExistenceError | i18next }}</mat-error>

        <div class="row">
            <div class="col-lg-6 notes-types-save">
                <button aum-button color="primary" [disabled]="!form.valid" type="submit" (click)="submit()">
                    {{ 'aumico_button_save' | i18next }}
                </button>
            </div>

            <div class="col-lg-6">
                <button aum-button (click)="onCancel()">{{ 'aumico_button_cancel' | i18next }}</button>
            </div>
        </div>
    </div>

    <h5 class="preview-title">{{ 'aumico_notes_preview' | i18next }}</h5>
    <h6 class="preview-title">{{ 'aumico_notes_preview_attention' | i18next }}</h6>
    <div class="notes-form-preview" *ngIf="(selectedComponents.length > 0) && (componentsData.size > 0)">
        <aumico-notes-preview
            #preview
            [componentOptions]="componentsData"
            [componentList]="getSelectedComponentsNames(selectedComponents)"
            [currentLanguage]="currentLanguage"
        ></aumico-notes-preview>
    </div>
</div>
